import { v4 as uuidv4 } from 'uuid'

export const custodyTestData = {
  title: 'Custody',
  item: 'N/A',
  key: uuidv4()
}
